import localeHelpers from "./LocaleHelper";

const clientHelper = {

        client: function () {
            return JSON.parse(localStorage.getItem('client'))
        },

        at: function () {
            return localStorage.getItem('at')
        },

        saveClient(client) {
            localStorage.setItem('client', JSON.stringify(client));
        },

        saveUserSession(data) {
            if (data.auth_token) localStorage.setItem('at', data.auth_token);
            localStorage.setItem('client', JSON.stringify(data.user));

            if (data.user && data.user.locale)
                localeHelpers.saveLocaleLocally(data.user.locale)
            else
                localeHelpers.saveLocaleLocally("en")
        },

        backgroundImage: function (target) {
            const business = this.business();
            let type = "yoga";
            if (business && business.b_type) type = business.b_type;
            switch (target) {
                case "class_overview":
                    switch (type) {
                        case "yoga":
                            return require("assets/img/theme/yoga-index.jpg");
                        case "gym":
                            return require("assets/img/theme/gym-index.jpg");
                        case "dance":
                            return require("assets/img/theme/dance-login.jpg");
                        case "school":
                            return require("assets/img/theme/yoga-index.jpg");
                        case "ma":
                            return require("assets/img/theme/ma-index.jpg");
                        default:
                            return require("assets/img/theme/yoga-index.jpg");
                    }
                case "index":
                    switch (type) {
                        case "yoga":
                            return require("assets/img/theme/yoga-index-4.jpg");
                        case "gym":
                            return require("assets/img/theme/gym-index.jpg");
                        case "dance":
                            return require("assets/img/theme/dance-index.jpg");
                        case "school":
                            return require("assets/img/theme/yoga-index.jpg");
                        case "ma":
                            return require("assets/img/theme/ma-index.jpg");
                        default:
                            return require("assets/img/theme/yoga-index.jpg");
                    }
                case "clients":
                    switch (type) {
                        case "yoga":
                            return require("assets/img/theme/yoga-index.jpg");
                        case "gym":
                            return require("assets/img/theme/gym-index.jpg");
                        case "dance":
                            return require("assets/img/theme/dance-login.jpg");
                        case "school":
                            return require("assets/img/theme/yoga-index.jpg");
                        case "ma":
                            return require("assets/img/theme/ma-index.jpg");
                        default:
                            return require("assets/img/theme/yoga-index.jpg");
                    }
                default:
                    break;
            }
        },

        isClientAccount(res) {
            const user_type = res.user.user_type;
            const current_user_type = res.current.user_type;

            return user_type === "c" || current_user_type === "c"
        },
    };

export default clientHelper;